import { z } from 'zod';
import type {
  ReverseInboundReceiptInventoryPostingRequest,
  ReverseInboundReceiptInventoryPostingResponse,
} from './reverse-inbound-receipt-inventory-posting.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const ReverseInboundReceiptInventoryPostingRequestSchema: z.ZodType<ReverseInboundReceiptInventoryPostingRequest> =
  z
    .object({
      companyId: z.uuid(),
      receiptId: z.uuid(),
      reason: z.string().trim().min(1).max(500).nullable().optional(),
    })
    .strict();

export const ReverseInboundReceiptInventoryPostingResponseSchema: z.ZodType<ReverseInboundReceiptInventoryPostingResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
    })
    .strict();
